export const EMAILS = ['info@global-construction.com.ua', 'kcanakli@global-construction.com.ua']
export const PHONE_NUMBERS = ['+380981044444']
export const FORMATTED_PHONE_NUMBERS = ['+380 98 104 4444']
export const ADDRESS = 'Україна, 03169, м. Київ, пров.Павла Лі, 2-б,'
export const FADE_ANIMATION_DURATION = 0.7
export const LIST_FADE_ANIMATION_DURATION = 0.5